import {ImagesBase} from './base';
import Avatar from 'assets/images/avatar.png';
import BusinessBranding from 'assets/images/business-branding.png';
import BusinessSecurity from 'assets/images/business-security.png';
import BusinessSharing from 'assets/images/business-sharing.png';
import EmptyBackground from 'assets/images/empty-bg.png';
import EmptyDrag from 'assets/images/empty-drag.png';
import WelcomeBrowse from 'assets/images/welcome-browse.png';
import WelcomeUpload from 'assets/images/welcome-upload.png';
import WelcomeView from 'assets/images/welcome-view.png';


class Images implements ImagesBase {
  avatar = Avatar;
  bizBranding = BusinessBranding;
  bizSecurity = BusinessSecurity;
  bizSharing = BusinessSharing;
  emptyBackground = EmptyBackground;
  emptyDrag = EmptyDrag;
  welcomeBrowse = WelcomeBrowse;
  welcomeUpload = WelcomeUpload;
  welcomeView = WelcomeView;
}

export default new Images();
